// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopReviewThumbnail_container__W_H9i","image":"ShopReviewThumbnail_image__U3zsq","imageCountPlaceholder":"ShopReviewThumbnail_imageCountPlaceholder__0hvZZ"};